// extracted by mini-css-extract-plugin
export default {"root":"ChatMessageAudio_root__m54Av"};